<!-- Main container with responsive styling -->
<div class="flex flex-col gap-10">
  <!-- Desktop title (only shown when not hidden and on md+) -->
  @if (!hideTitle()) {
    <div class="hidden md:block">
      <div
        class="inline-flex items-start justify-start gap-5 self-stretch pb-8"
      >
        <div
          class="flex w-full flex-wrap content-start items-start justify-start gap-2"
        >
          <div
            class="justify-start text-4xl leading-relaxed font-medium text-neutral-800"
          >
            {{
              'components.accordionContent.sections.authorGuidelines.title'
                | translate
            }}
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Content section with responsive layout - Updated to match design -->
  <div
    class="inline-flex flex-wrap content-start items-start justify-start gap-5 self-stretch pt-5 pb-16"
  >
    <!-- Section title -->
    <div
      class="flex w-full flex-wrap content-start items-start justify-start gap-2 md:w-2/5"
    >
      <div
        class="justify-start text-lg leading-normal font-semibold text-neutral-800"
      >
        {{
          'components.accordionContent.sections.authorGuidelines.instructions'
            | translate
        }}
      </div>
    </div>

    <!-- Content and download button -->
    <div class="inline-flex flex-1 flex-col items-start justify-start gap-8">
      <!-- Instructions text -->
      <div
        class="justify-start self-stretch text-base leading-normal font-normal text-neutral-800"
      >
        {{
          'components.accordionContent.sections.authorGuidelines.instructionsText'
            | translate
        }}
      </div>

      <!-- PDF Download button -->
      @if (getPdfUrl()) {
        <a
          class="inline-flex items-center justify-center gap-3 rounded-full bg-secondary-background px-5 py-2 transition-colors hover:bg-neutral-200"
          [href]="getPdfUrl()"
          target="_blank"
        >
          <div
            class="justify-start text-base leading-normal font-normal text-neutral-800"
          >
            {{
              'components.accordionContent.sections.authorGuidelines.pdfButtonText'
                | translate
            }}
          </div>
          <div class="relative h-6 w-6 overflow-hidden">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.99997 18H18V20H5.99997V18ZM11 4V12.586L6.70697 8.293L5.29297 9.707L12 16.414L18.707 9.707L17.293 8.293L13 12.586V4H11Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </a>
      }
    </div>
  </div>
</div>
